import { FieldType } from '@/catalog/constants/fieldTypes';
import { returnFieldValue } from '@/catalog/helpers/returnFieldValue';
import { Field } from '@/catalog/types/field';
import { ALL_CONTEXTS } from '@/common/constants/context';

import ProductInfo from '../../components/CatalogContent/ProductListContainer/ProductListCombo/ProductInfo/ProductInfo';

export const FIELD_SHORT_VIEW: Field = {
  label: 'Short View',
  fullLabel: 'Short View',
  key: 'shortView',
  type: FieldType.Scalar,
  getValue(p) {
    return p.shortView;
  },
  getText: returnFieldValue,
  render: (p) => <ProductInfo product={p} showB2BSid showPrice showTitle />,
  contexts: ALL_CONTEXTS,
};
